import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type Sentry from '@banking/ui/services/sentry';

export default class SignupRoute extends Route {
  @service sentry!: Sentry;

  redirect() {
    // Sentry should automatically include the URL as a tag
    this.sentry.withScope((scope) => {
      scope.setLevel('info');
      this.sentry.captureMessage('Encountered an unrecognized URL');
    });
    this.replaceWith('signup.index');
  }
}
